import React from 'react';

import Button from '../Button/Button';
import './buttonTeal.scss';

/**
 * Usage:
 * <ButtonTeal className="ikt-ws_make-own-cabinet">
 *     MAKE YOUR OWN CABINET
 * </ButtonTeal>
 */

const ButtonTeal = (props) => {
    return (
        <Button {...props} className={`teal${props.className ? ` ${props.className}` : ``}`}>
            {props.children}
        </Button>
    )
};

export default ButtonTeal;

